import { render, staticRenderFns } from "./CrmBoard.vue?vue&type=template&id=4158f868&scoped=true&"
import script from "./CrmBoard.vue?vue&type=script&lang=js&"
export * from "./CrmBoard.vue?vue&type=script&lang=js&"
import style0 from "./CrmBoard.vue?vue&type=style&index=0&id=4158f868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158f868",
  null
  
)

export default component.exports